//# sourceMappingURL=layout.mjs.map
/// <reference types="./layout.d.mts" />
import * as $when from "../../altar/altar/when.mjs";
import * as $remote from "../../data_types/data/remote.mjs";
import * as $redraw from "../../redraw/redraw.mjs";
import * as $a from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../redraw_dom/redraw/dom/html.mjs";
import * as $function from "../../tiamat/tiamat/function.mjs";
import * as $ai_config_effects from "../admin/effects/ai_config.mjs";
import * as $org_effects from "../admin/effects/organization.mjs";
import * as $user_effects from "../admin/effects/user.mjs";
import * as $weaviate_effects from "../admin/effects/weaviate.mjs";
import * as $route from "../data/route.mjs";
import * as $store from "../data/store.mjs";
import { toList } from "../gleam.mjs";
import * as $administration from "../view/administration.mjs";
import * as $content_library from "../view/content_library.mjs";
import * as $navbar from "../view/navbar.mjs";
import * as $organization from "../view/organization.mjs";
import * as $project_file from "../view/project/file/view.mjs";
import * as $project_versioning from "../view/project/versioning/list.mjs";
import * as $proposal_versioning from "../view/project/versioning/proposal.mjs";
import * as $proposal_translations_view from "../view/project/versioning/translations.mjs";
import * as $s from "../view/styles.mjs";

function use_organization_data() {
  let store = $store.use_state();
  let dispatch = $store.use_effect_dispatch();
  return ((_capture) => {
    return $redraw.use_effect(_capture, [store.organization]);
  })(
    () => {
      return $when.some_(
        store.organization,
        $function.always(undefined),
        (org_id) => {
          let _pipe = $store.organization_users(store);
          $remote.load(
            _pipe,
            () => {
              dispatch($org_effects.fetch_users(org_id));
              return undefined;
            },
          );
          let _pipe$1 = $store.organization_tags(store);
          $remote.load(
            _pipe$1,
            () => {
              dispatch($org_effects.fetch_tags(org_id));
              return undefined;
            },
          );
          let _pipe$2 = $store.organization_enabled_connections(store);
          $remote.load(
            _pipe$2,
            () => {
              dispatch($org_effects.fetch_connections(org_id));
              return undefined;
            },
          );
          let _pipe$3 = store.roles;
          $remote.load(
            _pipe$3,
            () => {
              dispatch($user_effects.fetch_roles());
              return undefined;
            },
          );
          let _pipe$4 = store.connections;
          $remote.load(
            _pipe$4,
            () => {
              dispatch($user_effects.fetch_connections());
              return undefined;
            },
          );
          let _pipe$5 = $store.organization_ai_config(store);
          $remote.load(
            _pipe$5,
            () => {
              dispatch($ai_config_effects.fetch_ai_config(org_id));
              return undefined;
            },
          );
          let _pipe$6 = $store.organization_weaviate_migrations(store);
          $remote.load(
            _pipe$6,
            () => {
              dispatch($weaviate_effects.fetch_migrations(org_id));
              return undefined;
            },
          );
          let _pipe$7 = $store.organization_weaviate_collections(store);
          return $remote.load(
            _pipe$7,
            () => {
              dispatch($weaviate_effects.fetch_collections(org_id));
              return undefined;
            },
          );
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    $navbar.navbar(),
    (navbar) => {
      return $redraw.compose(
        $administration.view(),
        (administration) => {
          return $redraw.compose(
            $content_library.view(),
            (content_library) => {
              return $redraw.compose(
                $organization.view(),
                (organization) => {
                  return $redraw.compose(
                    $project_file.view(),
                    (project_file) => {
                      return $redraw.compose(
                        $project_versioning.view(),
                        (project_versioning) => {
                          return $redraw.compose(
                            $proposal_versioning.view(),
                            (proposal_versioning) => {
                              return $redraw.compose(
                                $proposal_translations_view.view(),
                                (proposal_translations) => {
                                  return $redraw.component_(
                                    "Layout",
                                    (_) => {
                                      let store = $store.use_state();
                                      use_organization_data();
                                      return $redraw.fragment(
                                        toList([
                                          $s.layout(
                                            toList([]),
                                            toList([
                                              navbar(undefined),
                                              $s.main(
                                                toList([$a.id("layout-main")]),
                                                toList([
                                                  (() => {
                                                    let $ = store.route;
                                                    if (
                                                      $ instanceof $route.Administration
                                                    ) {
                                                      let route = $[0];
                                                      return administration(
                                                        [route],
                                                      );
                                                    } else if (
                                                      $ instanceof $route.ContentLibrary
                                                    ) {
                                                      let route = $[0];
                                                      return content_library(
                                                        [route],
                                                      );
                                                    } else if (
                                                      $ instanceof $route.Organization
                                                    ) {
                                                      let route = $[0];
                                                      return organization(
                                                        [route],
                                                      );
                                                    } else if (
                                                      $ instanceof $route.Project
                                                    ) {
                                                      return project_file(
                                                        undefined,
                                                      );
                                                    } else if (
                                                      $ instanceof $route.Proposal
                                                    ) {
                                                      let $1 = $[0];
                                                      if (
                                                        $1 instanceof $route.VersioningList
                                                      ) {
                                                        return project_versioning(
                                                          undefined,
                                                        );
                                                      } else if (
                                                        $1 instanceof $route.Versioning
                                                      ) {
                                                        let id = $1.proposal_id;
                                                        return proposal_versioning(
                                                          id,
                                                        );
                                                      } else {
                                                        let id = $1.proposal_id;
                                                        return proposal_translations(
                                                          id,
                                                        );
                                                      }
                                                    } else {
                                                      return $h.none();
                                                    }
                                                  })(),
                                                ]),
                                              ),
                                            ]),
                                          ),
                                        ]),
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
